import ListingHeader from "app/pages/Listing/ListingHeader/ListingHeader";
import { connect } from "react-redux";
import { getListingHeaderMerchandisings } from "app/pages/Merchandising/merchandisingSelector";
import {
	getTopDestinationFilterValues,
	getVisibleProducts,
} from "app/pages/Listing/productsSelector";
import find from "lodash/find";
import { bindActionCreators } from "redux";
import { setListingFilterStickness } from "app/pages/Header/menuActionCreators";
import { checkIfNavlogEnabled } from "app/pages/Listing/NavLogs/navLogsSelector";
import { getPartnerListingHero, getShowPfsMessage } from "app/reducers/partnerSelector";

const mapStateToProps = (state, props) => {
	const products = getVisibleProducts(state);
	const idSpotlight = props.idSpotlight;
	const topDestinationsFilterValues = getTopDestinationFilterValues(state);
	return {
		resolution: state.resolution,
		heroProduct: find(getVisibleProducts(state), product => {
			return product.uri && product.uri === idSpotlight;
		}),
		activeFilters: state.productsFilters,
		topDestinationsFilterValues: topDestinationsFilterValues,
		merchandisingHeader: getListingHeaderMerchandisings(state, idSpotlight).merchList,
		products,
		brand: state.brand.code,
		partnerCode: state.partner.code,
		isNavlogsEnabled: checkIfNavlogEnabled(state),
		marketingBanner: state.partner.marketingBanner,
		showPfsMessage: getShowPfsMessage(state),
		partnerListingHero: getPartnerListingHero(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			setListingFilterStickness,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ListingHeader);
